/**
 * Logged-out auth screens that sit on the home globe, matching /login.
 * @param {string} pathname
 * @returns {boolean}
 */
export function isAuthHeroPath(pathname) {
  return (
    pathname === "/login" ||
    pathname === "/forgot-password" ||
    pathname === "/reset-password"
  );
}
